module.exports = __webpack_public_path__ + "media/images/discover/offers/digital-voucher-app-1eb8d279c356e2b75c2a7bbbac2b8ab1.jpg";